module.exports = __webpack_public_path__ + "img/nbo-master.80821359.png";